module.exports = __webpack_public_path__ + "static/assets/a35c1b09880d75e4342a301dac655613.png";